import { render, staticRenderFns } from "./RetireMergeId.vue?vue&type=template&id=23b5b1a7&scoped=true&"
import script from "./RetireMergeId.vue?vue&type=script&lang=js&"
export * from "./RetireMergeId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b5b1a7",
  null
  
)

export default component.exports